import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/password-reset-token';

export class PasswordResetTokenService implements types.Handlers {
  private serviceEndpoint = '/password-reset-token';

  constructor(private axios: AxiosInstance) {}

  async requestPasswordReset(params: types.RequestPasswordResetParameters): Promise<void> {
    const { data } = await this.axios.post(this.serviceEndpoint, params.body);
    return data;
  }

  async getToken(params: types.GetTokenParameters): Promise<types.PasswordResetTokenResponse> {
    const { data } = await this.axios.get(`${this.serviceEndpoint}/${params.path.id}`);
    return data;
  }

  async updatePassword(params: types.UpdatePasswordParameters): Promise<types.SuccessResponse> {
    const { data } = await this.axios.put(`${this.serviceEndpoint}/${params.path.id}`, params.body);
    return data;
  }
}
